import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

const nSoundBars = 16;
const dataMap: any = { 0: 15, 1: 10, 2: 8, 3: 9, 4: 6, 5: 5, 6: 2, 7: 1, 8: 0, 9: 4, 10: 3, 11: 7, 12: 11, 13: 12, 14: 13, 15: 14 };

@Component({
  selector: 'app-chat-audio-level',
  templateUrl: './audio-level.component.html',
  styleUrls: ['./audio-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatAudioComponent implements OnInit {
  visualElements: any[] = [];
  audioStream: MediaStream;
  mediaStreamSource: MediaStreamAudioSourceNode;

  ngOnInit() {
    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
      .then((stream) => {
        this.audioStream = stream;
        this.visualElements = Array.from({length: nSoundBars}).map(() => ({transform: 1, opacity: 2}));
        const audioContext = new AudioContext();
        const analyzer = audioContext.createAnalyser();
        analyzer.smoothingTimeConstant = 0.5;
        analyzer.fftSize = 32;

        // Create a media stream source
        this.mediaStreamSource = audioContext.createMediaStreamSource(stream);
        this.mediaStreamSource.connect(analyzer);
        
        this.initializeRenderLoop(analyzer);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  initializeRenderLoop(analyzer: AnalyserNode) {
    const frequencyData = new Uint8Array(analyzer.frequencyBinCount);
    analyzer.getByteFrequencyData(frequencyData);
    this.processFrame(frequencyData);

    const renderFrame = () => {
      analyzer.getByteFrequencyData(frequencyData);
      this.processFrame(frequencyData);
      requestAnimationFrame(renderFrame);
    };
    requestAnimationFrame(renderFrame);
  }

  /**
   * Update visualization based on sound level
   * @param data Detected audio data
   */
  processFrame(data: any) {
    const values: any[] = Object.values(data);
    for (let i = 0; i < nSoundBars; i++ ) {
      const value = values[ dataMap[i] ] / 255;
      const elmStyle = this.visualElements[i];
      elmStyle.transform = `scaleY( ${ value } )`;
      elmStyle.opacity = Math.max( .25, value );
    }
  }

  ngOnDestroy() {
    if (this.audioStream != undefined) {
      this.audioStream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }
}
